import { render, staticRenderFns } from "./EditPassModal.vue?vue&type=template&id=5afc7a40"
import script from "./EditPassModal.vue?vue&type=script&lang=js"
export * from "./EditPassModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports